<template>
  <v-main>
    <v-container fluid>
      <OSimpleDialog
        :maxWidth="800"
        ref="helpDialog"
        title="Formato dos Dados"
        :showButtons="false"
      >
        <v-card-text class="pa-6 d-flex items-start">
          <pre>{{ helpText }}</pre>
        </v-card-text>
      </OSimpleDialog>

      <OSimpleDialog
        :maxWidth="800"
        ref="importDialog"
        title="Importar"
        @apply="doParse"
      >
        <v-card-text class="pa-6 d-flex items-start">
          <v-textarea
            :rows="15"
            class="textarea-mono"
            v-model="strInput"
            filled
            hide-details
          />
        </v-card-text>
      </OSimpleDialog>

      <div class="d-flex gap-6">
        <!-- h-600 -->
        <div class="w-1/3 h-600 d-flex flex-column">
          <!-- h-100% -->
          <v-card
            class="d-flex flex-column flex-grow-1 flex-shrink-1 max-h-full"
          >
            <!-- fixed bar -->
            <div
              class="card-bar d-flex items-center pa-2 flex-grow-0 flex-shrink-0"
            >
              <div class="pl-2 text-h6 font-weight-regular">Dados</div>
              <v-spacer />
              <v-switch
                v-model="showLabel"
                label="Destacar label"
                single-line
                hide-details
                class="mt-0"
              />
              <v-spacer />
              <v-btn @click="() => $refs.importDialog.open()">
                Carregar...
              </v-btn>
            </div>

            <!-- scrollable content -->
            <div class="flex-grow-1 flex-shrink-1 overflow-y-auto">
              <v-simple-table>
                <template v-slot:default>
                  <colgroup>
                    <col />
                    <col />
                    <col />
                    <col />
                    <col width="120" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>Lat</th>
                      <th>Lng</th>
                      <th>Extra0</th>
                      <th>Extra1</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody v-for="(path, idx) in paths" :key="idx">
                    <tr style="background-color: #ccc">
                      <td colspan="4">
                        Path {{ idx + 1 }} ({{ path.points.length }} points)
                      </td>
                      <td class="text-right">
                        <div class="hover-button">
                          <v-btn
                            icon
                            title="Apagar path e pontos"
                            @click="removePath(idx)"
                          >
                            <v-icon small>mdi-delete</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            title="Juntar com o anterior"
                            :disabled="idx == 0"
                            @click="mergePrevPath(idx)"
                          >
                            <v-icon small>mdi-arrow-expand-up</v-icon>
                          </v-btn>
                        </div>
                      </td>
                    </tr>
                    <tr
                      v-for="(p, jdx) in path.points"
                      :key="jdx"
                      @mouseover="highlight(path, p, jdx)"
                    >
                      <td>{{ p[0] }}</td>
                      <td>{{ p[1] }}</td>
                      <td>{{ p[2] }}</td>
                      <td>{{ p[3] }}</td>
                      <td class="text-right">
                        <!-- Concluí que é mais intuitivo cortar entre este ponto e o próximo, ao invés de entre este e o anterior. -->
                        <div class="hover-button">
                          <v-btn
                            icon
                            title="Cortar entre este e o anterior"
                            :disabled="jdx == path.points.length - 1"
                            @click="cutPath(idx, jdx + 1)"
                          >
                            <v-icon small>mdi-scissors-cutting</v-icon>
                          </v-btn>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-card>
        </div>

        <div class="w-2/3 h-600 overflow-y-scroll">
          <pre v-if="err != null">{{ err }}</pre>

          <div style="position: relative; height: 600px; width: 100%">
            <OMap2
              ref="theMap"
              :height="600"
              :paths="paths"
              :markers="markers"
              :maxZoom="23"
            />
          </div>
        </div>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import OSimpleDialog from 'oderon-vue/cpts/dialogs/OSimpleDialog.vue'
import OMap2 from 'oderon-vue/maps/OMap2.vue'
import { getBounds } from 'map-utils'

const helpText = `# Comentários
# Colunas podem ser separadas por espaços,
# tab, vírgula ou ponto-e-vírgula
# lat       lng         timestamp
-17.962353	-46.830027	2025-12-24 00:01:32
-17.962336	-46.830044	2025-12-24 00:06:54
-17.962321	-46.830049	2025-12-24 00:10:27

# Linhas em branco criam outros paths
-17.962321	-46.830047	2025-12-24 00:10:49
-17.962321	-46.830047	2025-12-24 00:11:11
-17.962325	-46.830056	2025-12-24 00:16:32
`

export default {
  components: {
    OMap2,
    OSimpleDialog
  },
  data() {
    return {
      helpText,
      now: new Date(),
      strInput: helpText,
      err: null,
      paths: [],
      highlightedPoint: null,
      showLabel: false
    }
  },
  watch: {
    paths: {
      handler() {
        let allPoints = []
        for (let path of this.paths)
          for (let pt of path.points) allPoints.push(pt)

        let bounds = getBounds(allPoints)
        setTimeout(() => this.$refs.theMap.fitBounds(bounds), 500)
      },
      immediate: true
    }
  },
  computed: {
    markers() {
      let point = this.highlightedPoint
      if (point == null) return []

      let label = null
      if (this.showLabel) {
        label = [nullIfEmpty(point[2]), nullIfEmpty(point[3])]
        label = label
          .filter((x) => x != null)
          .join('\n')
          .trim()

        label = nullIfEmpty(label)
      }

      let marker = {
        id: 'hlPoint',
        lat: point[0],
        lng: point[1],
        cssClass: 'solid-marker',
        label
      }

      return [marker]
    }
  },
  methods: {
    highlight(path, point /*, index*/) {
      this.highlightedPoint = point
    },
    doParse() {
      this.$refs.importDialog.dismiss()
      try {
        this.err = null
        this.paths = parse(this.strInput)
      } catch (err) {
        this.err = err
        this.paths = []
      }
    },

    mergePrevPath(idx) {
      if (idx == 0) return null

      let oldPath = this.paths.splice(idx, 1)[0]
      let prevPath = this.paths[idx - 1]

      for (let p of oldPath.points) prevPath.points.push(p)
    },

    removePath(idx) {
      if (idx == 0) return null
      this.paths.splice(idx, 1)
    },

    cutPath(idx, jdx) {
      if (jdx == 0) return null
      let prevPath = this.paths[idx]

      let len = prevPath.points.length - jdx
      let cutPoints = prevPath.points.splice(jdx, len)

      let newPath = { id: ++_sequence, points: cutPoints }
      this.paths.splice(idx + 1, 0, newPath)
    }
  }
}

function nullIfEmpty(x) {
  if (x == null) return null
  x = x.toString().trim()
  if (x.length > 0) return x
  return null
}

let _sequence = 0

function parse(strInput) {
  let result = []
  let head = null

  let lines = (strInput || '')
    .trim()
    .split('\n')
    .map((x) => x.trim())
  for (let line of lines) {
    if (line[0] == '#') {
      // ignora ou pega cor
    } else if (line.length < 1) {
      head = null // close()
    } else {
      if (head == null) {
        // open()
        head = { id: ++_sequence, points: [] }
        result.push(head)
      }

      // grow()
      let parts = line.split(/[ ;,\t]+/g)
      let lat = parseFloat(parts[0])
      let lng = parseFloat(parts[1])
      if (isValidCoord(lat, lng)) {
        head.points.push([lat, lng, parts[2], parts[3]])
      }
    }
  }

  return result
}

function isValidCoord(lat, lng) {
  // já descarta null, undefined, Infinity, NaN, etc
  if (betweenAndNotZero(lat, -90, 90) && betweenAndNotZero(lng, -180, 180)) {
    return true
  } else {
    return false
  }
}

function betweenAndNotZero(x, min, max) {
  // isFinite testa se não é: NaN, null, undefined, 0/0, etc
  if (!Number.isFinite(x)) return false
  if (x == 0) return false
  if (x < min) return false
  if (x > max) return false
  return true
}
</script>

<style lang="sass">
.textarea-mono
  font-family: 'Courier New', Courier, monospace
  font-size: 10pt
  white-space: pre

.textarea-border
  border: 1px solid #ccc
  border-radius: 8px

/* Hide the button initially */
.hover-button
  display: none

tr:hover .hover-button
  display: flex
  justify-content: flex-end

.solid-marker
  border-style: solid !important
  border-width: 5px !important
  border-color: black !important
  background-color: #00ff00 !important
</style>
